if (!customElements.get('saga-led-bundles')) {
  customElements.define('saga-led-bundles', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.onFormData = (event) => {
        const form = event.target;
        if (!(form instanceof HTMLFormElement)) return;
        if (form.id !== this.dataset.formId && form.id !== `${this.dataset.formId}-sticky`) return;
        if (String(event.formData.get('id')) !== this.dataset.variantId) return;
        const selected = this.querySelector('input:checked');
        if (selected && !selected.disabled) event.formData.set('quantity', selected.value);
      };
      document.addEventListener('formdata', this.onFormData, { signal });
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}
